export const defaultRedirectConfig = {
  publicRoute: "/",
  privateRoute: "/login",
} as const;
